import { connect } from 'react-redux';
import Profile from 'components/user/Profile';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      user: state.app.user,
      userParty: state.app.userParty,
    },
    state,
    'countries',
    'partyTypes',
    'regions',
    'taxOffices',
    'insurances',
    'memberships'
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
